export type StreamEvent = { type: string; data: unknown };

export async function readAssistantStream(
  body: ReadableStream<Uint8Array>,
  onEvent: (event: StreamEvent) => void
) {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let doneReceived = false;
  const drain = () => {
    let boundary: RegExpExecArray | null;
    while ((boundary = /\r?\n\r?\n/.exec(buffer))) {
      const frame = buffer.slice(0, boundary.index);
      buffer = buffer.slice(boundary.index + boundary[0].length);
      const lines = frame.split(/\r?\n/);
      const type = lines
        .find((line) => line.startsWith('event:'))
        ?.slice(6)
        .trim();
      const data = lines
        .filter((line) => line.startsWith('data:'))
        .map((line) => line.slice(5).trimStart())
        .join('\n');
      if (!type || !data) continue;
      onEvent({ type, data: JSON.parse(data) });
      if (type === 'done') doneReceived = true;
    }
  };
  try {
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      drain();
    }
    buffer += decoder.decode();
    drain();
    if (!doneReceived)
      throw new Error('Connection interrupted. Resume in this chat.');
  } finally {
    await reader.cancel().catch(() => undefined);
    reader.releaseLock();
  }
}
